const initialState = {
    darkMode: false,

    /* Projects: [
        {
            title: "Weather Forecast",
            address: "https://parthpakhare.github.io/react-weather-app/",
            logo: "Weather",
        },
        {
            title: "Trivia",
            address: "https://parthpakhare.github.io/react-weather-app/",
            logo: "Quiz"
        },
        {
            title: "Simple Calculator",
            address: "https://parthpakhare.github.io/react-weather-app/",
            logo: "Calculator"
        }
    ] */
}

const Reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case 'toggle':
            return{
                darkMode: !state.darkMode,
            }
            
            default:
                return state
            }
            
    //return state
    
}

export default Reducer;